import React from 'react';

export function PlaneRed(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 593 210"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={props.className}
			ref={props.selectChildRef}
		>
			<path d="M0 0h12.899l74.5 82.5 35 9.5H25.722L0 0z" fill="#EC1C24" />
			<circle cx={206.512} cy={194.434} r={15.113} fill="#24242C" />
			<circle cx={206.512} cy={195.172} r={5.529} fill="#6A6A6A" />
			<path fill="#24242C" d="M202.858 169h7.933v12.341h-7.933z" />
			<circle cx={247.06} cy={194.434} r={15.113} fill="#24242C" />
			<circle cx={247.06} cy={195.172} r={5.529} fill="#6A6A6A" />
			<path fill="#24242C" d="M243.406 169h7.933v12.341h-7.933z" />
			<circle cx={323.474} cy={194.434} r={15.113} fill="#24242C" />
			<circle cx={323.474} cy={195.172} r={5.529} fill="#6A6A6A" />
			<path fill="#24242C" d="M319.82 169h7.933v12.341h-7.933z" />
			<circle cx={364.022} cy={194.434} r={15.113} fill="#24242C" />
			<circle cx={364.022} cy={195.172} r={5.529} fill="#6A6A6A" />
			<path fill="#24242C" d="M360.368 169h7.933v12.341h-7.933z" />
			<circle cx={512.887} cy={194.434} r={15.113} fill="#24242C" />
			<circle cx={512.887} cy={195.172} r={5.529} fill="#6A6A6A" />
			<path fill="#24242C" d="M509.233 169h7.933v12.341h-7.933z" />
			<path
				d="M20 92h521v41.5L529 175H179.973a7.995 7.995 0 01-3.72-.918L20 92z"
				fill="#FD5E5F"
			/>
			<rect
				x={0.399}
				y={83}
				width={80}
				height={18}
				rx={9}
				fill="#E4E4E4"
			/>
			<path
				d="M593 124.163C593 147.082 562.212 175 523 175s-71-18.58-71-41.5S483.788 92 523 92s70 9.243 70 32.163z"
				fill="#FD5E5F"
			/>
			<path
				d="M549.399 95c0 11.046-31.116 20-69.5 20s-69.5-8.954-69.5-20 56.116-19 94.5-19 44.5 7.954 44.5 19z"
				fill="#FD5E5F"
			/>
			<path
				d="M425.399 110a6 6 0 016-6h2a6 6 0 016 6v5a6 6 0 01-6 6h-2a6 6 0 01-6-6v-5zM519.399 85a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2h-6a2 2 0 01-2-2v-6zM530.399 85a2 2 0 012-2h11.723l1.277 1 .86.86c.093.093.177.195.25.305l.89 1.335.5 1 .436.873c.043.084.079.172.109.262l.405 1.216c.033.1.059.2.076.304l.474 2.845h-17a2 2 0 01-2-2v-6zM445.399 110a6 6 0 016-6h2a6 6 0 016 6v5a6 6 0 01-6 6h-2a6 6 0 01-6-6v-5zM465.399 110a6 6 0 016-6h2a6 6 0 016 6v5a6 6 0 01-6 6h-2a6 6 0 01-6-6v-5zM491.399 110a6 6 0 016-6h2a6 6 0 016 6v5a6 6 0 01-6 6h-2a6 6 0 01-6-6v-5z"
				fill="#C4C4C4"
			/>
			<path
				d="M492.399 100.5h12a5.5 5.5 0 015.5 5.5v20a5.5 5.5 0 01-5.5 5.5h-12a5.5 5.5 0 01-5.5-5.5v-20a5.5 5.5 0 015.5-5.5z"
				stroke="#C4C4C4"
			/>
			<path
				d="M135.899 100.5h61.5l144 30V159l-137-25.981-68.5-32.519z"
				fill="#E4E4E4"
			/>
			<path
				d="M295.399 144.5c0-8.008 6.492-14.5 14.5-14.5h31.5a3 3 0 013 3v23a3 3 0 01-3 3h-31.5c-8.008 0-14.5-6.492-14.5-14.5z"
				fill="#EC1C24"
			/>
			<rect
				x={335.399}
				y={130}
				width={9}
				height={29}
				rx={3}
				fill="#8C0404"
			/>
			<path
				d="M211.399 138c0-8.284 6.716-15 15-15h31a3 3 0 013 3v24a3 3 0 01-3 3h-31c-8.284 0-15-6.716-15-15z"
				fill="#EC1C24"
			/>
			<rect
				x={251.399}
				y={123}
				width={9}
				height={30}
				rx={3}
				fill="#8C0404"
			/>
		</svg>
	);
}

export default PlaneRed;
